import React, { useState, useEffect } from 'react';
import WebDev from '../images/services/web-dev.png';
import LogoDesign from '../images/services/logo-design.png';
import Marketing from '../images/services/marketing.png';
import SEO from '../images/services/seo.png';
import './Services.css'

const Contact = () => {


  // ✅ Put useEffect HERE — inside the component
  useEffect(() => {
    const boxes = document.querySelectorAll(".even-box");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scrolled");
          } else {
            entry.target.classList.remove("scrolled");
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    boxes.forEach(box => observer.observe(box));

    return () => {
      boxes.forEach(box => observer.unobserve(box));
    };
  }, []);

  return (
    <div className="">
      {/* Hero Section Starts */}
      <div className="about-hero d-flex align-items-center">
        <div className="about-hero-inner container">
          <div className="hero-content">
            <h1 className="hero-title title display-3">Services</h1>
            <p>Home / Services</p>
          </div>
        </div>
      </div>
      {/* Hero Section Ends */}
      {/* <!-- services section start  --> */}
      <section className="container-fluid py-5 bg-light-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title-part d-flex  flex-column mb-5">
                <h3 className="mb-3 title fw-bold fs-4 letter-spacing-3">OUR SERVICES</h3>
                <h2 className=" display-4 fw-normal">We Provide Best Service To Our Clients</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={WebDev} className="img-fluid" alt="" />
                <h2 className="fs-5 text-white text-center mt-2">Web Design & Development</h2>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={Marketing} className="img-fluid" alt="" />
                <h2 className="fs-5 text-white text-center mt-2">Digital Marketing</h2>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={LogoDesign} className="img-fluid" alt="" />
                <h2 className="fs-5 text-white text-center mt-2">Logo Design</h2>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={SEO} className="img-fluid" alt="" />
                <h2 className="fs-5 text-white text-center mt-2">SEO</h2>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- services section end  --> */}

      {/* <!-- numbers boxes start --> */}

      <section class="container-fluid py-3 fade-box-main">
        <div class="container">
          <div class="row align-items-center justify-content-start my-5 ">
            <div class="col-lg-8 even-box">
              <div class="fade-box position-relative">
                <div class="number-box">
                  <h1 class="fade-number">01</h1>
                </div>
                <div class="number-text-box position-absolute">
                  <h2 class="title display-5">Strategic Planning & Research​</h2>
                  <p class="text-white fs-5">We start by understanding your business, audience, and goals. Our strategic approach ensures that whether it’s website development, branding, SEO, or social media marketing, every step is planned for success.</p>
                </div>
              </div>
            </div>

          </div>
          <div class="row align-items-center justify-content-center mt-sm-16 ">
            <div class="col-lg-8 even-box">
              <div class="fade-box position-relative">
                <div class="number-box">
                  <h1 class="fade-number text-center">02</h1>
                </div>
                <div class="number-text-box position-absolute text-center">
                  <h2 class="title display-5">Design, Development & Digital Solutions​</h2>
                  <p class="text-white fs-5">From WordPress and Webflow websites to logos, brand identities, and digital assets, we craft high-quality solutions that are both visually stunning and performance-driven. Our team delivers fast turnarounds without compromising on creativity or functionality.</p>
                </div>
              </div>
            </div>

          </div>
          <div class="row align-items-center justify-content-end mt-sm-12 ">
            <div class="col-lg-8 even-box">
              <div class="fade-box position-relative">
                <div class="number-box">
                  <h1 class="fade-number text-end">03</h1>
                </div>
                <div class="number-text-box position-absolute text-end">
                  <h2 class="title display-5">Marketing, Growth & Optimization​​</h2>
                  <p class="text-white fs-5">We go beyond just building websites—we help businesses attract, engage, and convert audiences. With SEO, paid advertising, content marketing, and social media strategies, we drive measurable results, boosting brand visibility and online growth.</p>
                </div>
              </div>
            </div>

          </div>

        </div>

      </section>

      {/* <!-- numbers boxes end --> */}
    </div>
  );
};

export default Contact;
